import styled from "styled-components";
import { Drawer } from "antd";

export const Sheet = styled(Drawer)`
  .ant-drawer-content-wrapper {
    box-shadow: 0px 0px 38px 0px #2d425929 !important;
  }

  .ant-drawer-content {
    background: #ffffff;
  }

  .ant-drawer-header {
    display: none;
  }

  .ant-drawer-body {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }

  .ant-drawer-mask {
    backdrop-filter: blur(2px);
    background: rgba(0, 0, 0, 0.28);
  }
`;

export const SheetInner = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 28px 24px 16px;
`;

export const Title = styled.h2`
  margin: 0;
  color: #000000;
  font-family: "Suisse International", sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: -0.02em;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 8px;

  svg {
    width: 14px;
    height: 14px;
    display: block;
  }

  &:hover {
    background: #f7f7f7;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 24px 16px;
  border-bottom: 1px solid #f0f0f0;
`;

export const FilterPill = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid ${({ $active }) => ($active ? "#111111" : "#e5e5e5")};
  background: ${({ $active }) => ($active ? "#111111" : "#ffffff")};
  color: ${({ $active }) => ($active ? "#ffffff" : "#666666")};
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: ${({ $active }) => ($active ? "#2a2a2a" : "#f7f7f7")};
    border-color: ${({ $active }) => ($active ? "#2a2a2a" : "#d1d1d1")};
  }
`;

export const FilterCount = styled.span<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: ${({ $active }) => ($active ? "22px" : "auto")};
  height: ${({ $active }) => ($active ? "22px" : "auto")};
  padding: ${({ $active }) => ($active ? "0 6px" : "0")};
  border-radius: 100px;
  background: ${({ $active }) => ($active ? "#444444" : "transparent")};
  color: ${({ $active }) => ($active ? "#ffffff" : "#666666")};
  font-family: "Inter", sans-serif;
  font-size: ${({ $active }) => ($active ? "11px" : "14px")};
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  line-height: 16px;
`;

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const DateGroupLabel = styled.p`
  margin: 0;
  padding: 10px 24px;
  color: #999999;
  font-family: "Inter", sans-serif;
  font-size: 11px;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  background: #f9f9f9;
  border-bottom: 1px solid #f0f0f0;
`;

export const NotificationCard = styled.article<{
  $unread: boolean;
  $layout?: "sheet" | "page";
}>`
  display: flex;
  gap: 12px;
  padding: ${({ $layout }) => ($layout === "page" ? "20px 24px" : "16px 24px")};
  background: ${({ $unread }) => ($unread ? "#fff9f7" : "#ffffff")};
  border-bottom: 1px solid #f0f0f0;
  cursor: default;

  &[role="button"] {
    cursor: pointer;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const TypeIcon = styled.div<{ $variant?: "success" | "failed" | "pending" }>`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  background: ${({ $variant }) => {
    if ($variant === "failed") return "#ffe4e6";
    if ($variant === "pending") return "#fff4d6";
    return "#dcfce7";
  }};

  svg {
    width: 22px;
    height: 22px;
    display: block;
  }
`;

export const CardBody = styled.div<{ $layout?: "sheet" | "page" }>`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
  padding-right: ${({ $layout }) => ($layout === "page" ? "160px" : "0")};

  @media (max-width: 768px) {
    padding-right: 0;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const CardSide = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  max-width: 150px;
  text-align: right;

  @media (max-width: 768px) {
    position: static;
    max-width: none;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    margin-top: 4px;
  }
`;

export const PageMeta = styled.p`
  margin: 0;
  color: #999999;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const CardTitle = styled.h3`
  margin: 0;
  color: #1a1a1a;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;

export const UnreadDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ff4a01;
  flex-shrink: 0;
`;

export const AmountRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Amount = styled.p`
  margin: 0;
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  color: #1a1a1a;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
`;

export const AmountCurrency = styled.span`
  color: #969696;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 100%;
`;

export const StatusPill = styled.span<{ $status: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 100px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-transform: capitalize;

  ${({ $status }) => {
    if ($status === "failed") {
      return `
        background: #ffe8ec;
        color: #f9123b;
      `;
    }

    if ($status === "pending") {
      return `
        background: rgba(253, 230, 138, 0.6);
        color: #78350f;
      `;
    }

    return `
      background: #ecfdf5;
      color: #0eab44;
    `;
  }}
`;

export const Source = styled.p`
  margin: 0;
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
`;

export const Description = styled.p`
  margin: 0;
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const ActionsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
`;

export const PrimaryAction = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  background: #111111;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  cursor: pointer;
  transition: background-color 0.15s ease;

  svg {
    width: 12px;
    height: 12px;
  }

  &:hover {
    background: #2a2a2a;
  }
`;

export const SecondaryAction = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #d1d1d1;
  border-radius: 8px;
  background: #ffffff;
  color: #111111;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  svg {
    width: 12px;
    height: 12px;
  }

  &:hover {
    background: #f7f7f7;
    border-color: #111111;
  }
`;

export const Meta = styled.p`
  margin: 4px 0 0;
  color: #999999;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const Footer = styled.div`
  padding: 16px 24px 24px;
  border-top: 1px solid #f0f0f0;
  background: #ffffff;
`;

export const ViewAllButton = styled.button`
  width: 100%;
  height: 44px;
  border: 1px solid #111111;
  border-radius: 8px;
  background: #ffffff;
  color: #111111;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background: #f7f7f7;
  }
`;

export const EmptyState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 32px;
  text-align: center;
`;

export const EmptyTitle = styled.h3`
  margin: 16px 0 8px;
  color: #000000;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
`;

export const EmptySubtitle = styled.p`
  margin: 0;
  max-width: 260px;
  color: #8f8f8f;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const ToastBanner = styled.div`
  position: fixed;
  left: 50%;
  bottom: 32px;
  transform: translateX(-50%);
  z-index: 1100;
  padding: 12px 20px;
  border-radius: 999px;
  background: #111111;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  pointer-events: none;
`;

export const BellButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const UnreadBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -8px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #ff6a00;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
`;
